import { spreadSearchQuery } from "helpers/utilities"
import { get, put, post, del, delData } from "../api_helper"
import * as moment from "moment"
import { BASE_URL } from "helpers/url_helper"

const BASE_API_URL = `${BASE_URL}/erp-products`


const getLisErpProducts = (parameters, reqBody) => {
    let q = spreadSearchQuery(parameters)
    return post(`${BASE_API_URL}/ls-erp-product?${q}`,reqBody)
}


export {
    getLisErpProducts
}